import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = ({ sections, activeSection }) => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element?.getBoundingClientRect()?.top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };

  return (
    <div className="bg-card border border-border rounded-lg liquid-shadow sticky top-24">
      {/* Mobile Toggle */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden w-full flex items-center justify-between p-4 text-left"
      >
        <span className="font-poppins font-semibold text-text-primary">Table of Contents</span>
        <Icon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-primary"
        />
      </button>
      {/* Content */}
      <div className={`${isOpen ? 'block' : 'hidden'} lg:block p-4 lg:p-6`}>
        <h3 className="hidden lg:block font-poppins font-semibold text-lg text-text-primary mb-4">
          Table of Contents
        </h3>
        <nav className="space-y-2">
          {sections?.map((section, index) => (
            <button
              key={section?.id}
              onClick={() => scrollToSection(section?.id)}
              className={`w-full text-left px-3 py-2 rounded-lg brand-transition text-sm ${
                activeSection === section?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'text-text-secondary hover:text-primary hover:bg-muted'
              }`}
            >
              <span className="font-medium">{index + 1}. </span>
              {section?.title}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TableOfContents;